// Scheduled Banner Carousel JS
if (!customElements.get('homepage-carousel')) {
  customElements.define(
    'homepage-carousel',
    class HomepageCarousel extends HTMLElement {
      // Get user location from local storage
      constructor() {
        super();
      }

      connectedCallback() {
        let userStoredLocation = userLocation.getStoredLocation();
        let scheduledBannerCarousel = this;
        this.backupScheduledBannerCarousel = scheduledBannerCarousel.cloneNode(true);
        if (userStoredLocation) {
          this.filterSlidesByLocation(userStoredLocation);
        }

        this.scheduleSwiperInit();

        subscribe(PUB_SUB_EVENTS.userLocationSet, (location) => {
          const activeCarousel = document.querySelector('.scheduled-banner-carousel');
          if (!activeCarousel) return;

          const restoredCarousel = this.backupScheduledBannerCarousel;
          activeCarousel.replaceWith(restoredCarousel);
          restoredCarousel.backupScheduledBannerCarousel = restoredCarousel.cloneNode(true);
          restoredCarousel.filterSlidesByLocation(location);
          restoredCarousel.scheduleSwiperInit();
        });
      }

      scheduleSwiperInit() {
        const initDelay = parseInt(this.dataset.swiperInitDelay || '0', 10);
        const init = () => this.loadSwiper().then(() => this.initSwiper());

        if (initDelay > 0) {
          setTimeout(() => window.luxoRunWhenIdle(init, 800), initDelay);
        } else {
          window.luxoRunWhenIdle(init, 800);
        }
      }

      loadSwiper() {
        if (window.Swiper) return Promise.resolve(window.Swiper);

        if (window.luxoLoadSwiper) {
          return window.luxoLoadSwiper().then(() => window.Swiper);
        }

        return window.luxoLoadScriptOnce(this.dataset.swiperSrc, { defer: true }).then(() => window.Swiper);
      }

      initSwiper() {
        const swiperContainer = this.querySelector('.swiper-container');
        const swiperWrapper = this.querySelector('.swiper-wrapper');
        const slides = this.querySelectorAll('.swiper-slide');

        if (!window.Swiper || !swiperContainer || !swiperWrapper || slides.length < 2 || swiperContainer.swiper) return;

        const bannerInterval = swiperWrapper.getAttribute('data-interval');
        const bannerSpeed = swiperWrapper.getAttribute('data-transition');

        this.swiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: bannerInterval,
            disableOnInteraction: false,
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          speed: bannerSpeed,
        });
      }

      filterSlidesByLocation(userStoredLocation) {
        const userLocationSuburb = userStoredLocation.suburb;
        // Filter out any slides that don't match the user's location
        let swiperSlides = this.querySelectorAll('.swiper-slide');
        swiperSlides.forEach((slide, index) => {
          const slideGeolocation = slide.dataset.geolocation;
          if (slideGeolocation === 'all') {
            return;
          }
          const cityName = this.getCityFromGeolocation(slideGeolocation);
          if (userLocationSuburb !== cityName.suburb) {
            slide.remove();
          }

          if (slideGeolocation !== 'all') {
            slide.style.opacity = '1';
          }

          return;
        });
      }

      getCityFromGeolocation(geolocation) {
        // Convert geolocation to suburb name
        // This is a placeholder function. You would need to implement the actual conversion logic.
        const cityCentre = CITY_CENTRES.find((cityCentre) => cityCentre.code === geolocation);

        if (cityCentre) {
          return cityCentre;
        }

        return false;
      }
    }
  );
}
